import BannerTop from "../sections/inicio/bannerTop";
import ImagesInfo from "../sections/inicio/ImagesInfo";
import BgOrange from "../sections/inicio/BgOrange";
import Public from "../sections/inicio/Public";
import DownDoc from "../sections/inicio/DownDoc";
import SectionContact from "../sections/inicio/contact/SectionContact";

const Inicio = () => {
  return (
    <>
      {/* Banner superior */}
      <BannerTop />

      {/* Sección de imágenes inferior */}
      <ImagesInfo />

      {/* Sección de texto y logo */}

      <BgOrange />

      {/* Sección de fondo verde */}
      <Public />

      {/* Seccion de Descargar PDF */}
      <DownDoc />

      {/* Sección de contacto */}
      <SectionContact />
    </>
  );
};

export default Inicio;
